module.exports = __webpack_public_path__ + "static/media/Food Product Name 2.0479a907.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/cont/Food Product Name 2.png
// module id = 416
// module chunks = 0